/**
 * PDF 导出 —— 用 html2pdf.js（基于 html2canvas + jsPDF）
 *
 * 微信浏览器兼容性提示：
 *  - 微信 X5 内核对 Blob 下载支持受限，部分机型下"自动下载"不会触发
 *  - 解决：弹出引导提示"请右上角…选择'用其他浏览器打开'"
 *  - 兜底方案：用户可长按"截图保存"，得到完整的视觉报告（虽然不是真 PDF）
 *
 * 性能：单次导出耗时约 5–15s（取决于图片数量和设备）
 */

declare global {
  interface Window {
    html2pdf?: any
  }
}

let html2pdfPromise: Promise<any> | null = null
async function loadHtml2pdf(): Promise<any> {
  if (!html2pdfPromise) {
    html2pdfPromise = import('html2pdf.js').then((m) => m.default ?? m)
  }
  return html2pdfPromise
}

function isWeChatBrowser(): boolean {
  const ua = navigator.userAgent || ''
  return /MicroMessenger/i.test(ua)
}

export async function exportReportToPdf(
  element: HTMLElement,
  filename: string = '邹城中考志愿测算报告.pdf'
): Promise<void> {
  const inWeChat = isWeChatBrowser()
  if (inWeChat) {
    const ok = confirm(
      '在微信内置浏览器中下载可能受限。\n' +
        '建议：点击右上角"…"→ 选择"用其他浏览器打开"再下载。\n\n' +
        '仍然继续尝试？'
    )
    if (!ok) return
  }

  // 显示导出中遮罩
  const mask = createMask()
  document.body.appendChild(mask)
  try {
    const html2pdf = await loadHtml2pdf()
    await html2pdf()
      .set({
        margin: 0,
        filename,
        image: { type: 'jpeg', quality: 0.92 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          backgroundColor: '#ffffff'
        },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        pagebreak: { mode: ['css', 'legacy'], avoid: '.card' }
      })
      .from(element)
      .save()
  } catch (err) {
    alert('PDF 导出失败：' + (err as Error).message + '\n建议长按页面截图保存。')
  } finally {
    mask.remove()
  }
}

function createMask(): HTMLElement {
  const mask = document.createElement('div')
  mask.style.cssText =
    'position:fixed;inset:0;background:rgba(0,0,0,0.6);z-index:9999;display:flex;align-items:center;justify-content:center;color:#fff;font-size:16px;'
  mask.innerHTML = `
    <div style="background:#fff;color:#333;padding:24px 32px;border-radius:12px;text-align:center;">
      <div style="font-size:18px;font-weight:500;margin-bottom:8px;">正在生成 PDF…</div>
      <div style="font-size:13px;color:#888;">通常需要 5–15 秒，请稍候</div>
    </div>
  `
  return mask
}
